import { AccessRequestForm } from "../components/AccessRequestForm";
import { SENFULLY_APP_URL } from "../appConfig";
import { STEPS } from "../content/steps";
import "./styles/GetSenfullyPage.css";

export function GetSenfullyPage() {
  return (
    <div className="section get-senfully container">
      <div className="get-senfully__layout">
        <div className="get-senfully__intro">
          <p className="eyebrow">Get SENfully</p>
          <h1 className="get-senfully__title">Let's get you started</h1>
          <p className="section__lead">
            SENfully is open by invitation while we welcome families in gradually. Tell us a little about yourself and we'll be in touch.
          </p>
        </div>

        <div className="get-senfully__card">
          <AccessRequestForm />
        </div>

        <div className="get-senfully__next">
          <ol className="get-senfully__steps">
            {STEPS.map((step, index) => (
              <li key={step.id}>
                <span className="get-senfully__number" aria-hidden="true">{index + 1}</span>
                <div>
                  <h2>{step.title}</h2>
                  <p>{step.description}</p>
                </div>
              </li>
            ))}
          </ol>

          <p className="get-senfully__login">Already have an account? <a href={SENFULLY_APP_URL}>Log in</a></p>
        </div>
      </div>
    </div>
  );
}
